export const openUrlInNewTab = (url: string) => {
  window.open(url, '_blank');
};

export const ShopifyExternalRoutes = (shopUrl: string) => {
  const basePath = getShopifyAdminUrlFromMyShopifyUrl(shopUrl);
  const buildUrl = (...args: string[]) => [basePath, ...args].join('/');
  return {
    customers: (id: string) => buildUrl('customers', id),
    orders: (id: string) => buildUrl('orders', id),
  };
};

export const getShopifyAdminUrlFromMyShopifyUrl = (myShopifyUrl: string) => {
  const shopName = myShopifyUrl.replace('.myshopify.com', '');
  return `https://admin.shopify.com/store/${shopName}`;
};
